var ye = Object.getOwnPropertySymbols;
var ke = Object.prototype.hasOwnProperty, he = Object.prototype.propertyIsEnumerable;
var q = (n, s) => {
  var m = {};
  for (var a in n)
    ke.call(n, a) && s.indexOf(a) < 0 && (m[a] = n[a]);
  if (n != null && ye)
    for (var a of ye(n))
      s.indexOf(a) < 0 && he.call(n, a) && (m[a] = n[a]);
  return m;
};
import "./style.css";
import { e as E, s as M, P as w, j as O, c as T, u as Pe } from "./formik-field-a445a7a0.js";
import { useRef as S, useImperativeHandle as A, useCallback as j, useLayoutEffect as je, useMemo as xe, useEffect as ve, useState as Ce } from "react";
import { u as C, p as y, a as re, F as Re } from "./toggle-d9514210.js";
import { A as lt, B as ct, b as nt, c as dt, C as it, d as ut, D as vt, e as ft, G as mt, f as pt, I as bt, g as Nt, L as Pt, M as xt, P as Rt, h as yt, R as kt, S as ht, i as jt, j as Ct, T as Ot, k as wt } from "./toggle-d9514210.js";
import "formik";
import "./carousel.messages-243a8ce8.js";
const Ae = (l) => {
  var N = l, {
    "data-o2-id": n,
    "data-testid": s,
    children: m,
    className: a,
    emitter: p,
    heading: v,
    id: f,
    o2Ref: c,
    onClose: t,
    onOpen: i,
    open: r,
    slot: o,
    style: u,
    type: d
  } = N, e = q(N, [
    "data-o2-id",
    "data-testid",
    "children",
    "className",
    "emitter",
    "heading",
    "id",
    "o2Ref",
    "onClose",
    "onOpen",
    "open",
    "slot",
    "style",
    "type"
  ]);
  const { styleProps: b } = E(e), x = M(b), P = S();
  A(
    c,
    () => P.current ? P.current : void 0,
    []
  );
  const h = j(() => {
    const R = w("o2Open");
    i == null || i(R);
  }, [i]), k = j(() => {
    const R = w("o2Close");
    t == null || t(R);
  }, [t]);
  return C({
    elementRef: P,
    eventName: "o2Open",
    eventCallback: h,
    emitter: p
  }), C({
    elementRef: P,
    eventName: "o2Close",
    eventCallback: k,
    emitter: p
  }), /* @__PURE__ */ O.jsx(
    "o2-accordion",
    {
      ref: P,
      id: f,
      "data-testid": s,
      "data-o2-id": n,
      class: T(a, x),
      type: d,
      heading: v,
      open: y(r),
      slot: o,
      style: u,
      children: m
    }
  );
}, De = (d) => {
  var e = d, {
    "data-testid": n,
    children: s,
    className: m,
    emitter: a,
    href: p,
    id: v,
    o2Ref: f,
    onClick: c,
    onReady: t,
    onRef: i,
    slot: r,
    style: o
  } = e, u = q(e, [
    "data-testid",
    "children",
    "className",
    "emitter",
    "href",
    "id",
    "o2Ref",
    "onClick",
    "onReady",
    "onRef",
    "slot",
    "style"
  ]);
  const { styleProps: l } = E(u), N = M(l), b = S();
  A(
    f,
    () => b.current ? b.current : void 0,
    []
  );
  const x = j(() => {
    t == null || t();
  }, [t]);
  return C({
    elementRef: b,
    eventName: "o2Ready",
    eventCallback: x,
    emitter: a
  }), re({
    elementRef: b,
    onRef: i
  }), /* @__PURE__ */ O.jsx(
    "o2-breadcrumbs-item",
    {
      ref: b,
      href: p,
      id: v,
      "data-testid": n,
      class: T(m, N),
      slot: r,
      style: o,
      onClick: c,
      children: s
    }
  );
}, Le = (o) => {
  var u = o, {
    "data-testid": n,
    children: s,
    className: m,
    color: a,
    emitter: p,
    id: v,
    o2Ref: f,
    onReady: c,
    slot: t,
    style: i
  } = u, r = q(u, [
    "data-testid",
    "children",
    "className",
    "color",
    "emitter",
    "id",
    "o2Ref",
    "onReady",
    "slot",
    "style"
  ]);
  const { styleProps: d } = E(r), e = M(d), l = S();
  A(
    f,
    () => l.current ? l.current : void 0,
    []
  );
  const N = j(() => {
    c == null || c();
  }, [c]);
  return C({
    elementRef: l,
    eventName: "o2Ready",
    eventCallback: N,
    emitter: p
  }), /* @__PURE__ */ O.jsx(
    "o2-breadcrumbs",
    {
      ref: l,
      color: a,
      id: v,
      "data-testid": n,
      class: T(m, e),
      slot: t,
      style: i,
      children: s
    }
  );
}, Be = (e) => {
  var l = e, {
    "data-o2-id": n,
    "data-testid": s,
    children: m,
    className: a,
    disabled: p,
    emitter: v,
    id: f,
    o2Ref: c,
    onClick: t,
    selected: i,
    slot: r,
    style: o,
    switchable: u
  } = l, d = q(l, [
    "data-o2-id",
    "data-testid",
    "children",
    "className",
    "disabled",
    "emitter",
    "id",
    "o2Ref",
    "onClick",
    "selected",
    "slot",
    "style",
    "switchable"
  ]);
  const { styleProps: N } = E(d), b = M(N), x = S();
  A(
    c,
    () => x.current ? x.current : void 0,
    []
  );
  const P = j(() => {
    const h = w("o2Click");
    t == null || t(h);
  }, [t]);
  return C({
    elementRef: x,
    eventName: "o2Click",
    eventCallback: P,
    emitter: v
  }), /* @__PURE__ */ O.jsx(
    "o2-chip",
    {
      ref: x,
      id: f,
      "data-testid": s,
      "data-o2-id": n,
      class: T(a, b),
      disabled: y(p),
      switchable: y(u),
      selected: y(i),
      slot: r,
      style: o,
      children: m
    }
  );
}, Ge = (d) => {
  var e = d, {
    "data-testid": n,
    children: s,
    className: m,
    emitter: a,
    id: p,
    lineClamp: v,
    moreLink: f,
    o2Ref: c,
    onClick: t,
    slot: i,
    sourceType: r = "html",
    style: o
  } = e, u = q(e, [
    "data-testid",
    "children",
    "className",
    "emitter",
    "id",
    "lineClamp",
    "moreLink",
    "o2Ref",
    "onClick",
    "slot",
    "sourceType",
    "style"
  ]);
  const { styleProps: l } = E(u), N = M(l), b = S();
  A(
    c,
    () => b.current ? b.current : void 0,
    []
  );
  const x = j(() => {
    if (r === "text") {
      const k = new DOMParser().parseFromString(s, "text/html").querySelector("html"), R = document.createRange().createContextualFragment(k.innerHTML);
      b.current.appendChild(R);
    }
  }, [b, s, r]);
  je(() => {
    b != null && b.current && x();
  }, [x, b]);
  const P = j(() => {
    const h = w("o2Click");
    t == null || t(h);
  }, [t]);
  return C({
    elementRef: b,
    eventName: "o2Click",
    eventCallback: P,
    emitter: a
  }), /* @__PURE__ */ O.jsx(
    "o2-content",
    {
      ref: b,
      id: p,
      "data-testid": n,
      class: T(m, N),
      slot: i,
      style: o,
      "line-clamp": v,
      "more-link": f,
      children: r === "html" && s
    }
  );
}, We = (Q) => {
  var ne = Q, {
    "data-o2-id": n,
    "data-testid": s,
    className: m,
    color: a = "default",
    dateFormat: p,
    disabled: v,
    emitter: f,
    error: c,
    formFieldClassName: t,
    id: i,
    inline: r,
    label: o,
    max: u,
    min: d,
    name: e,
    o2Ref: l,
    onChange: N,
    onClose: b,
    onMonthChange: x,
    onOpen: P,
    onReady: h,
    onYearChange: k,
    placeholder: R,
    readonly: J,
    required: oe,
    showRequirementText: Z,
    slot: W,
    style: K,
    help: V,
    type: le,
    value: G,
    warning: L,
    children: _
  } = ne, ee = q(ne, [
    "data-o2-id",
    "data-testid",
    "className",
    "color",
    "dateFormat",
    "disabled",
    "emitter",
    "error",
    "formFieldClassName",
    "id",
    "inline",
    "label",
    "max",
    "min",
    "name",
    "o2Ref",
    "onChange",
    "onClose",
    "onMonthChange",
    "onOpen",
    "onReady",
    "onYearChange",
    "placeholder",
    "readonly",
    "required",
    "showRequirementText",
    "slot",
    "style",
    "help",
    "type",
    "value",
    "warning",
    "children"
  ]);
  const { styleProps: Y } = E(ee), $ = M(Y), D = S();
  A(
    l,
    () => D.current ? D.current : void 0,
    []
  );
  const {
    fieldName: pe,
    fieldValue: de,
    fieldError: fe,
    iconColor: X,
    error: g,
    onFieldChange: te,
    onFieldBlur: se
  } = Pe(e, a), ae = xe(() => fe ? g : V, [fe, g, V]), ue = j(
    (z) => {
      const B = w("o2Change", {
        value: z.detail.value,
        name: e
      });
      N == null || N(B);
    },
    [e, N]
  ), F = j(
    (z) => {
      const B = w("o2Close", {
        value: z.detail.value,
        name: e
      });
      b == null || b(B), te == null || te(B), setTimeout(() => {
        se == null || se(B);
      });
    },
    [e, b, se, te]
  ), I = j(
    (z) => {
      const B = w("o2MonthChange", {
        value: z.detail.value,
        name: e
      });
      x == null || x(B);
    },
    [e, x]
  ), H = j(
    (z) => {
      const B = w("o2Open", {
        value: z.detail.value,
        name: e
      });
      P == null || P(B);
    },
    [e, P]
  ), ce = j(
    (z) => {
      const B = w("o2Ready", {
        value: z.detail.value,
        name: e
      });
      h == null || h(B);
    },
    [e, h]
  ), me = j(
    (z) => {
      const B = w("o2YearChange", {
        value: z.detail.value,
        name: e
      });
      k == null || k(B);
    },
    [e, k]
  );
  return C({
    elementRef: D,
    eventName: "o2Change",
    eventCallback: ue,
    emitter: f
  }), C({
    elementRef: D,
    eventName: "o2Close",
    eventCallback: F,
    emitter: f
  }), C({
    elementRef: D,
    eventName: "o2MonthChange",
    eventCallback: I,
    emitter: f
  }), C({
    elementRef: D,
    eventName: "o2Open",
    eventCallback: H,
    emitter: f
  }), C({
    elementRef: D,
    eventName: "o2Ready",
    eventCallback: ce,
    emitter: f
  }), C({
    elementRef: D,
    eventName: "o2YearChange",
    eventCallback: me,
    emitter: f
  }), ve(() => {
    if (!s)
      throw new Error(
        'Datetime component requires "data-testid" attribute which is passed to o2-datetime web component.'
      );
  }, [s]), /* @__PURE__ */ O.jsxs(
    Re,
    {
      disabled: v,
      readonly: J,
      error: X === "red",
      warning: X === "orange",
      slot: W,
      className: T(t),
      style: K,
      children: [
        /* @__PURE__ */ O.jsx(
          "o2-datetime",
          {
            ref: D,
            label: o,
            placeholder: R,
            min: d,
            max: u,
            type: le,
            inline: r,
            "date-format": p,
            disabled: y(v),
            readonly: y(J),
            required: y(oe),
            id: i,
            "show-requirement-text": Z,
            "data-testid": s,
            class: T(m, $),
            "data-o2-id": n,
            value: de != null ? de : G,
            name: pe,
            warning: y(L != null ? L : X === "orange"),
            error: y(c != null ? c : X === "red"),
            children: _
          }
        ),
        /* @__PURE__ */ O.jsx("span", { slot: "help-text", style: { display: ae ? "inline-block" : "none" }, children: ae })
      ]
    }
  );
}, ge = (x) => {
  var P = x, {
    "data-o2-id": n,
    "data-testid": s,
    action: m,
    autocomplete: a,
    children: p,
    className: v,
    emitter: f,
    error: c,
    id: t,
    method: i,
    name: r,
    native: o = !0,
    o2Ref: u,
    onKeyDown: d,
    onSubmit: e,
    slot: l,
    style: N
  } = P, b = q(P, [
    "data-o2-id",
    "data-testid",
    "action",
    "autocomplete",
    "children",
    "className",
    "emitter",
    "error",
    "id",
    "method",
    "name",
    "native",
    "o2Ref",
    "onKeyDown",
    "onSubmit",
    "slot",
    "style"
  ]);
  const { styleProps: h } = E(b), k = M(h), R = S();
  A(
    u,
    () => R.current ? R.current : void 0,
    []
  );
  const J = j(
    (Z) => {
      let W = {};
      Z.detail.formData instanceof FormData ? Z.detail.formData.forEach((V, le) => {
        W[le] = V;
      }) : W = Z.detail.formData;
      const K = w("o2Submit", {
        value: W,
        name: r
      });
      e == null || e(K);
    },
    [r, e]
  ), oe = j(
    (Z) => {
      const W = w("keydown", {
        name: r,
        value: Z.key
      });
      d == null || d(W);
    },
    [r, d]
  );
  return C({
    elementRef: R,
    eventName: "o2Submit",
    eventCallback: J,
    emitter: f
  }), C({
    elementRef: R,
    eventName: "keydown",
    eventCallback: oe,
    emitter: f
  }), ve(() => {
    if (!s)
      throw new Error('Form component requires "data-testid" attribute.');
  }, [s]), /* @__PURE__ */ O.jsx(
    "o2-form",
    {
      ref: R,
      "data-o2-id": n,
      error: y(c),
      id: t,
      "data-testid": s,
      class: T(v, k),
      slot: l,
      style: N,
      native: y(o, !0),
      action: m,
      method: i,
      autocomplete: a,
      children: p
    }
  );
}, He = (e) => {
  var l = e, {
    "data-o2-id": n,
    "data-o2-reporting": s,
    "data-testid": m,
    active: a,
    children: p,
    className: v,
    fill: f,
    href: c,
    id: t,
    o2Ref: i,
    onClick: r,
    slot: o,
    style: u
  } = l, d = q(l, [
    "data-o2-id",
    "data-o2-reporting",
    "data-testid",
    "active",
    "children",
    "className",
    "fill",
    "href",
    "id",
    "o2Ref",
    "onClick",
    "slot",
    "style"
  ]);
  const { styleProps: N } = E(d), b = M(N), x = S();
  return A(
    i,
    () => x.current ? x.current : void 0,
    []
  ), /* @__PURE__ */ O.jsx(
    "o2-metro-item",
    {
      ref: x,
      href: c,
      onClick: r,
      active: a,
      fill: f,
      class: T(v, b),
      id: t,
      "data-testid": m,
      slot: o,
      style: u,
      "data-o2-id": n,
      "data-o2-reporting": s,
      children: p
    }
  );
}, ze = (u) => {
  var d = u, {
    "data-o2-id": n,
    "data-o2-reporting": s,
    "data-testid": m,
    children: a,
    className: p,
    emitter: v,
    id: f,
    o2Ref: c,
    onReady: t,
    slot: i,
    style: r
  } = d, o = q(d, [
    "data-o2-id",
    "data-o2-reporting",
    "data-testid",
    "children",
    "className",
    "emitter",
    "id",
    "o2Ref",
    "onReady",
    "slot",
    "style"
  ]);
  const { styleProps: e } = E(o), l = M(e), N = S();
  A(
    c,
    () => N.current ? N.current : void 0,
    []
  );
  const b = j(() => {
    const x = w("o2Ready");
    t == null || t(x);
  }, [t]);
  return C({
    elementRef: N,
    eventName: "o2Ready",
    eventCallback: b,
    emitter: v
  }), /* @__PURE__ */ O.jsx(
    "o2-metro",
    {
      ref: N,
      class: T(p, l),
      style: r,
      slot: i,
      id: f,
      "data-testid": m,
      "data-o2-id": n,
      "data-o2-reporting": s,
      children: a
    }
  );
}, Je = (x) => {
  var P = x, {
    "data-o2-id": n,
    "data-testid": s,
    changeContext: m,
    className: a,
    disabled: p,
    id: v,
    label: f,
    multiple: c,
    name: t,
    o2Ref: i,
    onRef: r,
    placeholder: o,
    readonly: u,
    slot: d,
    style: e,
    token: l,
    value: N
  } = P, b = q(P, [
    "data-o2-id",
    "data-testid",
    "changeContext",
    "className",
    "disabled",
    "id",
    "label",
    "multiple",
    "name",
    "o2Ref",
    "onRef",
    "placeholder",
    "readonly",
    "slot",
    "style",
    "token",
    "value"
  ]);
  const { styleProps: h } = E(b), k = M(h), R = S();
  return A(
    i,
    () => R.current ? R.current : void 0,
    []
  ), re({
    elementRef: R,
    onRef: r
  }), /* @__PURE__ */ O.jsx(
    "o2-msisdn-selector",
    {
      ref: R,
      id: v,
      "data-testid": s,
      "data-o2-id": n,
      class: T(a, k),
      disabled: y(p),
      readonly: y(u),
      multiple: y(c),
      label: f,
      value: N,
      name: t,
      placeholder: o,
      token: l,
      "change-context": y(m, !0),
      slot: d,
      style: e
    }
  );
}, Qe = (r) => {
  var o = r, {
    "data-testid": n,
    children: s,
    className: m,
    color: a = "brand-blue",
    id: p,
    o2Ref: v,
    size: f = "medium",
    slot: c,
    style: t
  } = o, i = q(o, [
    "data-testid",
    "children",
    "className",
    "color",
    "id",
    "o2Ref",
    "size",
    "slot",
    "style"
  ]);
  const { styleProps: u } = E(i), d = M(u), e = S();
  return A(
    v,
    () => e.current ? e.current : void 0,
    []
  ), /* @__PURE__ */ O.jsx(
    "o2-notification-badge",
    {
      ref: e,
      id: p,
      "data-testid": n,
      class: T(m, d),
      color: a,
      size: f,
      slot: c,
      style: t,
      children: s
    }
  );
}, Xe = (o) => {
  var u = o, {
    id: n,
    "data-testid": s,
    o2Ref: m,
    style: a,
    className: p,
    slot: v,
    htmlFor: f,
    onValid: c,
    children: t,
    emitter: i
  } = u, r = q(u, [
    "id",
    "data-testid",
    "o2Ref",
    "style",
    "className",
    "slot",
    "htmlFor",
    "onValid",
    "children",
    "emitter"
  ]);
  const { styleProps: d } = E(r), e = M(d), l = S();
  A(
    m,
    () => l.current ? l.current : void 0,
    []
  );
  const N = j(
    (b) => {
      const x = w("o2Valid", {
        value: b.detail
      });
      c == null || c(x);
    },
    [c]
  );
  return C({
    elementRef: l,
    eventName: "o2Valid",
    eventCallback: N,
    emitter: i
  }), /* @__PURE__ */ O.jsx(
    "o2-password-indicator",
    {
      id: n,
      ref: l,
      "data-testid": s,
      class: T(p, e),
      style: a,
      slot: v,
      for: f,
      children: t
    }
  );
}, Ze = (D) => {
  var pe = D, {
    id: n,
    color: s = "default",
    help: m,
    formFieldClassName: a,
    styleFormField: p,
    "data-testid": v,
    o2Ref: f,
    style: c,
    className: t,
    slot: i,
    "data-o2-id": r,
    autocapitalize: o = "off",
    ariaLabel: u,
    ariaPlaceholder: d,
    autocomplete: e = "off",
    autocorrect: l = "off",
    autofocus: N = !1,
    disabled: b = !1,
    inputmode: x,
    minLength: P,
    maxLength: h,
    name: k,
    placeholder: R,
    readonly: J = !1,
    required: oe = !1,
    showRequirementText: Z = !1,
    value: W = "",
    label: K,
    pattern: V,
    leadingIcon: le,
    onBlur: G,
    onChange: L,
    onFocus: _,
    onInput: ee,
    onKeyUp: Q,
    children: ne,
    emitter: Y
  } = pe, $ = q(pe, [
    "id",
    "color",
    "help",
    "formFieldClassName",
    "styleFormField",
    "data-testid",
    "o2Ref",
    "style",
    "className",
    "slot",
    "data-o2-id",
    "autocapitalize",
    "ariaLabel",
    "ariaPlaceholder",
    "autocomplete",
    "autocorrect",
    "autofocus",
    "disabled",
    "inputmode",
    "minLength",
    "maxLength",
    "name",
    "placeholder",
    "readonly",
    "required",
    "showRequirementText",
    "value",
    "label",
    "pattern",
    "leadingIcon",
    "onBlur",
    "onChange",
    "onFocus",
    "onInput",
    "onKeyUp",
    "children",
    "emitter"
  ]);
  const { styleProps: de } = E($), fe = M(de), X = S(), [g, te] = Ce(W);
  ve(() => {
    te(W);
  }, [W]), A(
    f,
    () => X.current ? X.current : void 0,
    []
  );
  const { fieldError: se, error: ae, fieldName: ue, fieldValue: F, iconColor: I, onFieldChange: H, onFieldBlur: ce } = Pe(
    k,
    s
  ), me = xe(() => se ? ae : m, [se, ae, m]), z = j(
    (U) => {
      const Ne = w("o2Input", {
        value: U.detail.target.value,
        name: k
      });
      te(U.detail.target.value), H == null || H(Ne), ee == null || ee(Ne), L == null || L(Ne);
    },
    [k, ee, L, H]
  ), B = j(() => {
    const U = w("o2Blur", {
      value: F ? F.trim() : g.trim(),
      name: k
    });
    te(F ? F.trim() : g.trim()), H == null || H(U), L == null || L(U), ce == null || ce(U), G == null || G(U);
  }, [F, k, G, L, ce, H, g]), ie = j(
    (U) => {
      const Ne = w("o2KeyUp", {
        value: U.detail.key,
        name: k
      });
      Q == null || Q(Ne);
    },
    [k, Q]
  ), be = j(() => {
    const U = w("o2Focus", {
      name: k
    });
    _ == null || _(U);
  }, [k, _]);
  return ve(() => {
    if (!v)
      throw new Error(
        'Password component requires "data-testid" attribute which is passed to o2-password web component.'
      );
  }, [v]), C({
    elementRef: X,
    eventName: "o2Focus",
    eventCallback: be,
    emitter: Y
  }), C({
    elementRef: X,
    eventName: "o2Input",
    eventCallback: z,
    emitter: Y
  }), C({
    elementRef: X,
    eventName: "o2Blur",
    eventCallback: B,
    emitter: Y
  }), C({
    elementRef: X,
    eventName: "o2Keyup",
    eventCallback: ie,
    emitter: Y
  }), /* @__PURE__ */ O.jsxs(
    Re,
    {
      disabled: b,
      readonly: J,
      error: I === "red",
      warning: I === "orange",
      slot: i,
      className: T(a),
      style: p,
      children: [
        /* @__PURE__ */ O.jsx(
          "o2-password",
          {
            ref: X,
            "aria-label": u,
            "aria-placeholder": d,
            autocapitalize: o,
            "show-requirement-text": Z,
            autocomplete: e,
            autocorrect: l,
            autofocus: y(N),
            disabled: y(b),
            inputmode: x,
            name: ue,
            placeholder: R,
            readonly: y(J),
            required: y(oe),
            value: F != null ? F : g,
            label: K,
            "data-o2-id": r,
            id: n,
            "data-testid": v,
            class: T(t, fe),
            warning: y(I === "orange"),
            error: y(I === "red"),
            "leading-icon": le,
            minlength: P,
            maxlength: h,
            pattern: V,
            style: c,
            children: ne
          }
        ),
        /* @__PURE__ */ O.jsx("span", { slot: "help-text", style: { display: me ? "inline-block" : "none" }, children: me })
      ]
    }
  );
}, _e = (N) => {
  var b = N, {
    "data-testid": n,
    borderRadiusLeft: s,
    borderRadiusRight: m,
    className: a,
    color: p = "primary",
    height: v,
    id: f,
    max: c,
    min: t,
    o2Ref: i,
    size: r,
    slot: o,
    style: u,
    text: d,
    value: e
  } = b, l = q(b, [
    "data-testid",
    "borderRadiusLeft",
    "borderRadiusRight",
    "className",
    "color",
    "height",
    "id",
    "max",
    "min",
    "o2Ref",
    "size",
    "slot",
    "style",
    "text",
    "value"
  ]);
  const { styleProps: x } = E(l), P = M(x), h = S();
  return A(
    i,
    () => h.current ? h.current : void 0,
    []
  ), /* @__PURE__ */ O.jsx(
    "o2-progress",
    {
      ref: h,
      id: f,
      "data-testid": n,
      class: T(a, P),
      "border-radius-left": y(s, !0),
      "border-radius-right": y(m, !0),
      color: p,
      height: v,
      max: c,
      min: t,
      text: d,
      value: e,
      size: r,
      slot: o,
      style: u
    }
  );
}, $e = (W) => {
  var K = W, {
    "data-o2-id": n,
    "data-testid": s,
    className: m,
    color: a,
    decimals: p,
    emitter: v,
    from: f,
    icons: c,
    id: t,
    max: i,
    min: r,
    name: o,
    o2Ref: u,
    onChange: d,
    onEnd: e,
    onStart: l,
    onUpdate: N,
    simple: b,
    slot: x,
    staticLabel: P,
    step: h,
    style: k,
    suffix: R,
    to: J,
    type: oe
  } = K, Z = q(K, [
    "data-o2-id",
    "data-testid",
    "className",
    "color",
    "decimals",
    "emitter",
    "from",
    "icons",
    "id",
    "max",
    "min",
    "name",
    "o2Ref",
    "onChange",
    "onEnd",
    "onStart",
    "onUpdate",
    "simple",
    "slot",
    "staticLabel",
    "step",
    "style",
    "suffix",
    "to",
    "type"
  ]);
  const { styleProps: V } = E(Z), le = M(V), G = S();
  A(
    u,
    () => G.current ? G.current : void 0,
    []
  );
  const { onFieldChange: L, onFieldBlur: _ } = Pe(o, "default");
  ve(() => {
    if (!s)
      throw new Error('Slider component requires "data-testid" attribute.');
  }, [s]);
  const ee = j(
    ($) => {
      const D = w("o2Update", {
        value: $.detail.values,
        name: o
      });
      N == null || N(D);
    },
    [o, N]
  ), Q = j(
    ($) => {
      const D = w("o2Change", {
        value: $.detail.values,
        name: o
      });
      d == null || d(D), L == null || L(D);
    },
    [o, d, L]
  ), ne = j(
    ($) => {
      const D = w("o2Start", {
        value: $.detail.values,
        name: o
      });
      l == null || l(D);
    },
    [o, l]
  ), Y = j(
    ($) => {
      const D = w("o2End", {
        value: $.detail.values,
        name: o
      });
      e == null || e(D), _ == null || _(D);
    },
    [o, e, _]
  );
  return C({
    elementRef: G,
    eventName: "o2Update",
    eventCallback: ee,
    emitter: v
  }), C({
    elementRef: G,
    eventName: "o2Change",
    eventCallback: Q,
    emitter: v
  }), C({
    elementRef: G,
    eventName: "o2Start",
    eventCallback: ne,
    emitter: v
  }), C({
    elementRef: G,
    eventName: "o2End",
    eventCallback: Y,
    emitter: v
  }), /* @__PURE__ */ O.jsx(
    "o2-slider",
    {
      ref: G,
      id: t,
      "data-testid": s,
      class: T(m, le),
      "data-o2-id": n,
      type: oe,
      min: r,
      max: i,
      step: h,
      from: f,
      to: J,
      suffix: R,
      color: a,
      decimals: p,
      icons: y(c),
      simple: y(b),
      "static-label": y(P),
      slot: x,
      style: k
    }
  );
}, Fe = (r) => {
  var o = r, {
    "data-testid": n,
    children: s,
    className: m,
    id: a,
    o2Ref: p,
    onClick: v,
    onRef: f,
    slot: c,
    style: t
  } = o, i = q(o, [
    "data-testid",
    "children",
    "className",
    "id",
    "o2Ref",
    "onClick",
    "onRef",
    "slot",
    "style"
  ]);
  const { styleProps: u } = E(i), d = M(u), e = S();
  return A(
    p,
    () => e.current ? e.current : void 0,
    []
  ), re({
    elementRef: e,
    onRef: f
  }), /* @__PURE__ */ O.jsx(
    "o2-swiper-slide",
    {
      ref: e,
      id: a,
      "data-testid": n,
      class: T(m, d),
      slot: c,
      style: t,
      onClick: v,
      children: s
    }
  );
}, Ye = (x) => {
  var P = x, {
    id: n,
    "data-testid": s,
    className: m,
    children: a,
    onRef: p,
    o2Ref: v,
    navigation: f,
    pagination: c,
    centeredSlides: t,
    customOptions: i,
    freeMode: r,
    loop: o,
    direction: u,
    slidesPerView: d,
    spaceBetween: e,
    slot: l,
    style: N
  } = P, b = q(P, [
    "id",
    "data-testid",
    "className",
    "children",
    "onRef",
    "o2Ref",
    "navigation",
    "pagination",
    "centeredSlides",
    "customOptions",
    "freeMode",
    "loop",
    "direction",
    "slidesPerView",
    "spaceBetween",
    "slot",
    "style"
  ]);
  const { styleProps: h } = E(b), k = M(h), R = S();
  return A(
    v,
    () => R.current ? R.current : void 0,
    []
  ), ve(() => {
    R != null && R.current && (p == null || p(R));
  }, [R, p]), /* @__PURE__ */ O.jsx(
    "o2-swiper",
    {
      ref: R,
      id: n,
      "data-testid": s,
      class: T(m, k),
      navigation: y(f),
      pagination: y(c),
      "centered-slides": y(t),
      "custom-options": y(i),
      "free-mode": y(r),
      loop: y(o),
      direction: u,
      "slides-per-view": d,
      "space-between": e,
      slot: l,
      style: N,
      children: a
    }
  );
}, Ie = (o) => {
  var u = o, {
    "data-testid": n,
    children: s,
    className: m,
    id: a,
    name: p,
    o2Ref: v,
    onRef: f,
    selected: c,
    slot: t,
    style: i
  } = u, r = q(u, [
    "data-testid",
    "children",
    "className",
    "id",
    "name",
    "o2Ref",
    "onRef",
    "selected",
    "slot",
    "style"
  ]);
  const { styleProps: d } = E(r), e = M(d), l = S();
  return A(
    v,
    () => l.current ? l.current : void 0,
    []
  ), re({
    elementRef: l,
    onRef: f
  }), /* @__PURE__ */ O.jsx(
    "o2-tab-content",
    {
      ref: l,
      name: p,
      id: a,
      "data-testid": n,
      class: T(m, e),
      selected: y(c),
      slot: t,
      style: i,
      children: s
    }
  );
}, Ue = (l) => {
  var N = l, {
    "data-testid": n,
    children: s,
    className: m,
    emitter: a,
    heading: p,
    id: v,
    o2Ref: f,
    onClick: c,
    onRef: t,
    onSelected: i,
    panel: r,
    selected: o,
    slot: u,
    style: d
  } = N, e = q(N, [
    "data-testid",
    "children",
    "className",
    "emitter",
    "heading",
    "id",
    "o2Ref",
    "onClick",
    "onRef",
    "onSelected",
    "panel",
    "selected",
    "slot",
    "style"
  ]);
  const { styleProps: b } = E(e), x = M(b), P = S();
  A(
    f,
    () => P.current ? P.current : void 0,
    []
  );
  const h = j(
    (k) => {
      const R = w("o2Selected", {
        selected: k.detail.selected
      });
      i == null || i(R);
    },
    [i]
  );
  return C({
    elementRef: P,
    eventName: "o2Selected",
    eventCallback: h,
    emitter: a
  }), re({
    elementRef: P,
    onRef: t
  }), /* @__PURE__ */ O.jsx(
    "o2-tab",
    {
      ref: P,
      panel: r,
      heading: p,
      selected: y(o),
      id: v,
      "data-testid": n,
      class: T(m, x),
      slot: u,
      style: d,
      onClick: c,
      children: s
    }
  );
}, Ke = (o) => {
  var u = o, {
    "data-testid": n,
    children: s,
    className: m,
    id: a,
    o2Ref: p,
    onRef: v,
    selected: f,
    slot: c,
    style: t,
    type: i = "default"
  } = u, r = q(u, [
    "data-testid",
    "children",
    "className",
    "id",
    "o2Ref",
    "onRef",
    "selected",
    "slot",
    "style",
    "type"
  ]);
  const { styleProps: d } = E(r), e = M(d), l = S();
  return A(
    p,
    () => l.current ? l.current : void 0,
    []
  ), re({
    elementRef: l,
    onRef: v
  }), /* @__PURE__ */ O.jsx(
    "o2-tabs",
    {
      ref: l,
      selected: f,
      id: a,
      "data-testid": n,
      class: T(m, e),
      slot: c,
      type: i,
      style: t,
      children: s
    }
  );
}, Ve = (l) => {
  var N = l, {
    "data-testid": n,
    children: s,
    className: m,
    closable: a,
    color: p,
    disabled: v,
    emitter: f,
    id: c,
    o2Ref: t,
    onClick: i,
    onClose: r,
    size: o,
    slot: u,
    style: d
  } = N, e = q(N, [
    "data-testid",
    "children",
    "className",
    "closable",
    "color",
    "disabled",
    "emitter",
    "id",
    "o2Ref",
    "onClick",
    "onClose",
    "size",
    "slot",
    "style"
  ]);
  const { styleProps: b } = E(e), x = M(b), P = S();
  A(
    t,
    () => P.current ? P.current : void 0,
    []
  );
  const h = j(() => {
    const k = w("o2Close");
    r == null || r(k);
  }, [r]);
  return C({
    elementRef: P,
    eventName: "o2Close",
    eventCallback: h,
    emitter: f
  }), /* @__PURE__ */ O.jsx(
    "o2-tag",
    {
      ref: P,
      id: c,
      "data-testid": n,
      class: T(m, x),
      disabled: y(v),
      onClick: i,
      size: o,
      color: p,
      closable: a,
      slot: u,
      style: d,
      children: s
    }
  );
}, et = (pe) => {
  var de = pe, {
    "data-o2-id": n,
    "data-testid": s,
    autoGrow: m,
    autocapitalize: a = "none",
    autofocus: p,
    className: v,
    color: f = "default",
    cols: c,
    disabled: t,
    emitter: i,
    enterkeyhint: r,
    error: o,
    formFieldClassName: u,
    id: d,
    inputmode: e,
    label: l,
    maxlength: N,
    minlength: b,
    name: x,
    o2Ref: P,
    onBlur: h,
    onChange: k,
    onFocus: R,
    onInput: J,
    onRef: oe,
    placeholder: Z,
    readonly: W,
    required: K,
    rows: V,
    showRequirementText: le,
    slot: G,
    spellcheck: L,
    style: _,
    value: ee = "",
    warning: Q,
    wrap: ne,
    help: Y,
    children: $
  } = de, D = q(de, [
    "data-o2-id",
    "data-testid",
    "autoGrow",
    "autocapitalize",
    "autofocus",
    "className",
    "color",
    "cols",
    "disabled",
    "emitter",
    "enterkeyhint",
    "error",
    "formFieldClassName",
    "id",
    "inputmode",
    "label",
    "maxlength",
    "minlength",
    "name",
    "o2Ref",
    "onBlur",
    "onChange",
    "onFocus",
    "onInput",
    "onRef",
    "placeholder",
    "readonly",
    "required",
    "rows",
    "showRequirementText",
    "slot",
    "spellcheck",
    "style",
    "value",
    "warning",
    "wrap",
    "help",
    "children"
  ]);
  const { styleProps: fe } = E(D), X = M(fe), g = S();
  A(
    P,
    () => g.current ? g.current : void 0,
    []
  );
  const {
    fieldName: te,
    fieldError: se,
    iconColor: ae,
    fieldValue: ue,
    error: F,
    onFieldChange: I,
    onFieldBlur: H
  } = Pe(x, f), ce = xe(() => se ? F : Y, [se, F, Y]), me = j(() => {
    const ie = w("o2Blur", {
      name: x
    });
    H == null || H(ie), h == null || h(ie);
  }, [x, h, H]), z = j(() => {
    const ie = w("o2Focus", {
      name: x
    });
    R == null || R(ie);
  }, [x, R]), B = j(
    (ie) => {
      const be = w("o2Input", {
        value: ie.detail.target.value,
        name: x
      });
      I == null || I(be), J == null || J(be), k == null || k(be);
    },
    [x, k, I, J]
  );
  return C({
    elementRef: g,
    eventName: "o2Focus",
    eventCallback: z,
    emitter: i
  }), C({
    elementRef: g,
    eventName: "o2Blur",
    eventCallback: me,
    emitter: i
  }), C({
    elementRef: g,
    eventName: "o2Input",
    eventCallback: B,
    emitter: i
  }), re({
    elementRef: g,
    onRef: oe
  }), ve(() => {
    if (!s)
      throw new Error('TextArea component requires "data-testid" attribute.');
  }, [s]), /* @__PURE__ */ O.jsxs(
    Re,
    {
      disabled: t,
      readonly: W,
      error: o != null ? o : ae === "red",
      warning: Q != null ? Q : ae === "orange",
      slot: G,
      className: T(u),
      style: _,
      children: [
        /* @__PURE__ */ O.jsx(
          "o2-textarea",
          {
            ref: g,
            "show-requirement-text": le,
            id: d,
            "data-testid": s,
            class: T(v, X),
            "data-o2-id": n,
            value: ue != null ? ue : ee,
            name: te,
            "auto-grow": m,
            autocapitalize: a,
            autofocus: y(p),
            cols: c,
            disabled: y(t),
            enterkeyhint: r,
            inputmode: e,
            label: l,
            maxlength: N,
            minlength: b,
            placeholder: Z,
            readonly: y(W),
            required: y(K),
            rows: V,
            spellcheck: y(L),
            wrap: ne,
            warning: y(Q != null ? Q : ae === "orange"),
            error: y(o != null ? o : ae === "red"),
            children: $
          }
        ),
        /* @__PURE__ */ O.jsx("span", { slot: "help-text", style: { display: ce ? "inline-block" : "none" }, children: ce })
      ]
    }
  );
}, tt = (o) => {
  var u = o, {
    "data-testid": n,
    children: s,
    className: m,
    id: a,
    o2Ref: p,
    onRef: v,
    placement: f,
    slot: c,
    stack: t,
    style: i
  } = u, r = q(u, [
    "data-testid",
    "children",
    "className",
    "id",
    "o2Ref",
    "onRef",
    "placement",
    "slot",
    "stack",
    "style"
  ]);
  const { styleProps: d } = E(r), e = M(d), l = S();
  return A(
    p,
    () => l.current ? l.current : void 0,
    []
  ), re({
    elementRef: l,
    onRef: v
  }), /* @__PURE__ */ O.jsx(
    "o2-toast-container",
    {
      ref: l,
      placement: f,
      stack: t,
      id: a,
      "data-testid": n,
      class: T(m, e),
      slot: c,
      style: i,
      children: s
    }
  );
}, st = (l) => {
  var N = l, {
    slot: n,
    "data-testid": s,
    children: m,
    className: a,
    closable: p,
    color: v,
    duration: f,
    emitter: c,
    id: t,
    o2Ref: i,
    onHide: r,
    onRef: o,
    onShow: u,
    style: d
  } = N, e = q(N, [
    "slot",
    "data-testid",
    "children",
    "className",
    "closable",
    "color",
    "duration",
    "emitter",
    "id",
    "o2Ref",
    "onHide",
    "onRef",
    "onShow",
    "style"
  ]);
  const { styleProps: b } = E(e), x = M(b), P = S();
  A(
    i,
    () => P.current ? P.current : void 0,
    []
  );
  const h = j(() => {
    const R = w("o2Show");
    u == null || u(R);
  }, [u]), k = j(() => {
    const R = w("o2Hide");
    r == null || r(R);
  }, [r]);
  return C({
    elementRef: P,
    eventName: "o2Show",
    eventCallback: h,
    emitter: c
  }), C({
    elementRef: P,
    eventName: "o2Hide",
    eventCallback: k,
    emitter: c
  }), re({
    elementRef: P,
    onRef: o
  }), /* @__PURE__ */ O.jsx(
    "o2-toast",
    {
      ref: P,
      closable: p,
      duration: f,
      color: v,
      id: t,
      "data-testid": s,
      class: T(a, x),
      slot: n,
      style: d,
      children: m
    }
  );
}, at = (i) => {
  var r = i, {
    "data-testid": n,
    children: s,
    className: m,
    id: a,
    o2Ref: p,
    onRef: v,
    slot: f,
    style: c
  } = r, t = q(r, [
    "data-testid",
    "children",
    "className",
    "id",
    "o2Ref",
    "onRef",
    "slot",
    "style"
  ]);
  const { styleProps: o } = E(t), u = M(o), d = S();
  return A(
    p,
    () => d.current ? d.current : void 0,
    []
  ), re({
    elementRef: d,
    onRef: v
  }), /* @__PURE__ */ O.jsx(
    "o2-tooltip-wrapper",
    {
      ref: d,
      id: a,
      "data-testid": n,
      class: T(m, u),
      slot: f,
      style: c,
      children: s
    }
  );
};
export {
  Ae as Accordion,
  lt as Alert,
  ct as Badge,
  nt as Box,
  Le as Breadcrumbs,
  De as BreadcrumbsItem,
  dt as Button,
  it as Carousel,
  ut as Checkbox,
  Be as Chip,
  Ge as Content,
  We as Datetime,
  vt as Dropdown,
  ge as Form,
  Re as FormField,
  ft as FormTooltip,
  mt as Gallery,
  pt as Icon,
  bt as IconButton,
  Nt as Input,
  Pt as Loader,
  ze as Metro,
  He as MetroItem,
  xt as Modal,
  Je as MsisdnSelector,
  Qe as NotificationBadge,
  Ze as Password,
  Xe as PasswordIndicator,
  Rt as Picture,
  _e as Progress,
  yt as Radio,
  kt as RadioGroup,
  ht as Search,
  jt as Select,
  $e as Slider,
  Ct as Status,
  Ye as Swiper,
  Fe as SwiperSlide,
  Ue as Tab,
  Ie as TabContent,
  Ke as Tabs,
  Ve as Tag,
  et as TextArea,
  st as Toast,
  tt as ToastContainer,
  Ot as Toggle,
  wt as Tooltip,
  at as TooltipWrapper
};
//# sourceMappingURL=wc.js.map
